<template>
  <v-card class="align-stretch">
    <card-label-bar bold-text> Account info </card-label-bar>

    <v-card-text>
      <v-list class="profile__info__wrap">
        <v-list-item
          v-for="(item, i) in accountInfo"
          :key="i"
          three-line
          class="info__item col-12"
        >
          <v-list-item-content>
            <v-list-item-title class="caption text--secondary">
              {{ item.label }}
              <v-icon v-if="item.status === 'verified'" small color="blue">
                mdi-check-circle
              </v-icon>
            </v-list-item-title>
            <v-list-item-subtitle class="text-subtitle-2 text--primary">
              {{
                item.label === "Password"
                  ? item.value.replace(/./gi, "•")
                  : item.value
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="my-0 align-self-center">
            <v-btn
              v-if="item.type === 'button'"
              @click="editInfo(item)"
              text
              color="blue"
              class="mr-n4"
            >
              {{ item.btn }}
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed: {
    accountInfo() {
      return this.$store.getters["Profile/accountInfo"];
    },
  },

  methods: {
    toggleSideSheet(payload) {
      this.$store.dispatch("SideSheet/toggleSideSheet", payload);
    },
    editInfo(item) {
      if (item.label === "Email address") {
        this.toggleSideSheet({ isOn: true, isComponent: "account-info-form" });
      } else {
        this.toggleSideSheet({
          isOn: true,
          isComponent: "change-password-form",
        });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.profile__info__wrap
  margin: -12px
  padding: 0

  .info__item
    display: inline-flex
    min-height: 32px

    .v-list-item__content
      align-content: flex-start
      align-items: flex-start
      align-self: flex-start
      padding: 0 0 8px
</style>
